import PropTypes from 'prop-types';
import React, {Component} from "react";

import {connect} from "react-redux";
import rules from 'abusesa-js/rules';
import autobind from "autobind-decorator";

import AutoCompleteElement from "abusesa-js/components/AutoComplete.jsx";
import TriggerMixin from "./Modal.jsx";

import Charts from "../charts/index";

import "./SettingsModal.css";

const RANGES = [
    "",
    "last 7 days",
    "last 30 days",
    "last 3 months",
    "this week",
    "this month",
    "this quarter",
    "this year"
];

let currentQ = Math.ceil((new Date().getUTCMonth() + 1) / 3),
    currentY = new Date().getUTCFullYear();

for (let i = 0, q, y; i < 5; i++) {
    q = currentQ - i;
    y = currentY + Math.floor((q - 1) / 4);
    RANGES.push(y + "-Q" + (1 + (q + 7) % 4));
}


function getChartOptions(type) {
    let chartTypes = Object.keys(Charts);

    let opts = [
        {name: "dataset", label: "Data", type: "datasets"},
        {name: "type", label: "Chart Type", type: "select", values: chartTypes}
    ];

    let filters = [
        [
            {name: "topFilter", type: "select", values: ["", "top", "bottom"], condition: conf => conf.groupBy},
            //{name: "topFn", type: "select", values: ["last", "sum", "average"], condition: conf => conf.groupBy && conf.topFilter},
            {name: "topCount", label: "Count", type: "number", condition: conf => conf.groupBy && conf.topFilter},
            {name: "topShowOthers", label: "Show Avg", type: "checkbox", condition: conf => conf.groupBy && conf.topFilter}
        ],
        {name: "timespan", type: "autocomplete", values: RANGES.slice()},
        {name: "filter", type: "text"}
    ];

    let chartOpts = [...filters];

    if (Charts[type]) {
        let chart = Charts[type];
        let defaults = chart.options;

        const applyDefaults = opts => {
            let res = [];
            for (let opt of opts) {
                if (Array.isArray(opt)) {
                    res.push(applyDefaults(opt));
                } else {
                    res.push(defaults[opt.name] ? {...opt, defaultValue: defaults[opt.name]} : opt);
                }
            }

            return res;
        };

        chartOpts = applyDefaults([...chart.configOptions, ...chartOpts]);
    }

    return [...opts, ...chartOpts];
}


class CheckBox extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        checked: PropTypes.bool
    };

    @autobind
    handleChange(event) {
        this.props.onChange({value: event.target.checked, key: this.props.name});
    }

    render() {
        let {name, checked} = this.props;
        return <input
            type="checkbox"
            name={name}
            checked={checked}
            onChange={this.handleChange}
        />;
    }
}

class Input extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.any
    };

    @autobind
    handleChange(event) {
        this.props.onChange({value: event.target.value, key: this.props.name});
    }

    isInvalid(value) {
        return this.props.name == "filter" && !rules.parse(value);
    }

    render() {
        return (
            <input
                {...this.props}
                className={this.isInvalid(this.props.value) ? "invalid": ""}
                onChange={this.handleChange}
            />
        );
    }
}

const DEBOUNCE_DELAY = 400;
class DebouncedInput extends Input {
    constructor(...args) {
        super(...args);
        this.state = {value: null};
        this._timer = null;
    }

    @autobind
    forwardChanges() {
        clearTimeout(this._timer);
        this._timer = null;
        let value = this.state.value;
        let key = this.props.name;

        if (value !== null && value !== this.props.value) {
            this.props.onChange({value, key});
        }
    }

    @autobind
    handleChange({target}) {
        let value = target.value;
        this.setState({value});
        clearTimeout(this._timer);
        this._timer = setTimeout(this.forwardChanges, DEBOUNCE_DELAY);
    }

    componentWillUnmount() {
        if (this._timer) {
            this.forwardChanges();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.props.value) {
            this.setState({value: null});
        }
    }

    render() {
        let value = this.state.value != null ? this.state.value : this.props.value;

        return (
            <input
                {...this.props}
                value={value}
                className={this.isInvalid(value) ? "invalid": ""}
                onChange={this.handleChange}
                onBlur={this.forwardChanges}
            />
        );
    }
}


class Select extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.any,
        type: PropTypes.string,
        values: PropTypes.array
    };

    @autobind
    handleChange(event) {
        let key = this.props.name;
        let value = event.target.value;
        this.props.onChange({value, key});
    }

    render() {
        let {values = [], value, type} = this.props;

        let invalid = false;

        if (values.indexOf(value) == -1) {
            values = [value].concat(values);
            if (type === "keys") {
                invalid = true;
            }
        }
        return (
            <select {...this.props} className={invalid? "invalid": ""} onChange={this.handleChange}>
                {
                    values.map((val, i)=> {
                        return <option
                            key={i}
                            value={val}
                            disabled={invalid && val === value}
                        > {val} </option>;
                    })
                }
            </select>
        );
    }
}


class Item extends Component {
    static propTypes = {
        label: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.any,
        values: PropTypes.array,
        placeholder: PropTypes.string,
        type: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    render() {
        let {label, name, value, placeholder, type="text", onChange, values} = this.props;
        placeholder = placeholder || "< " + name + " >";
        label = label || name.replace(/([A-Z])/g, ' $1');

        let props = {placeholder, value, onChange, name, values},
            input;

        props = {...props, type};


        if (type == "keys" || type == "select") {
            input = <Select {...props} />;
        } else if (type == "datasets" || type == "autocomplete") {
            input = <AutoCompleteElement {...props} />;
        } else if (type == "checkbox") {
            props = {...props, checked: !!props.value};
            input = <CheckBox {...props}/>;
        } else if (type == "text") {
            input = <DebouncedInput {...props}/>;
        } else {
            input = <Input {...props}/>;
        }

        return (
            <div className="item">
                <label>{label}</label>
                {input}
            </div>
        );
    }
}


class Settings extends Component {
    static propTypes = {
        settings: PropTypes.object,
        datasets: PropTypes.array,
        keys: PropTypes.object,
        values: PropTypes.array,
        type: PropTypes.string,
        onChange: PropTypes.func.isRequired
    };

    @autobind
    onChange({value, key}) {
        let changed = {};
        changed[key] = value;

        let {settings} = this.props;
        this.props.onChange({...settings, ...changed});
    }

    render() {
        const {settings, datasets, keys} = this.props;

        const wrap = (props, i) => {
            if (typeof props === "string") {
                props = {name: props};
            }

            if (!props.values) {
                if (props.type == "keys") {
                    let filter = props.filter ? props.filter : (types, key) => true;
                    let suggestions = {
                        values: [""].concat(
                            Object.keys(keys)
                                .filter(key => filter(keys[key], key))
                                .sort()
                        )
                    };
                    props = {...props, ...suggestions};
                } else if (props.type == "datasets") {
                    let suggestions = {values: datasets};
                    props = {...props, ...suggestions};
                }
            }

            let defaults = {onChange: this.onChange};

            if (Array.isArray(props)) {
                return <Multi key={i} {...defaults}>{props.map(wrap)}</Multi>;
            } else {
                if (typeof props.condition === "function" && !props.condition(settings, keys)) {
                    return null;
                }

                let value = settings[props.name];
                if (value === void 0) {
                    value = "defaultValue" in props ? props.defaultValue : "";
                }

                return <Item value={value} {...props} {...defaults} key={props.name}/>;
            }
        };

        const rows = getChartOptions(settings.type);

        return (
            <div className="settings">
                <div className="Options">
                    {rows.map(wrap)}
                </div>
            </div>
        );
    }
}

class Multi extends Component {
    static propTypes = {
        children: PropTypes.node
    };

    render() {
        return <div className="multi">{this.props.children}</div>;
    }
}

let datasetNames = (() => {
    let prev = [];
    return obj => {
        let names = [...new Set(
            Object.keys(obj)
                .filter(key => obj[key].failed !== true)
                .map(key => obj[key].name)
                .map(name => name.split("#")[0])
        )];

        names = names.length == prev.length ? prev : names;
        prev = names;
        return names;
    };
})();

@connect(state => ({
    datasets: datasetNames(state.datasets)
}), null, null, {withRef: true})
export default class SettingsModal extends TriggerMixin {
    static defaultProps = {
        title: "Configuration"
    };

    static propTypes = {
        datasets: PropTypes.array,
        dataset: PropTypes.object,
        settings: PropTypes.object,
        onChange: PropTypes.func.isRequired
    };

    static displayName = 'SettingsModal';

    renderContent() {
        let {dataset} = this.props;
        let {keys, keytypes} = dataset;
        if (keytypes) {
            const typemap = {
                "count": ["number"],
                "time": ["time", "string"],
                "uniques": ["number"]
            };

            for (let key of Object.keys(keytypes)) {
                if (!keys[key]) {
                    keys[key] = typemap[keytypes[key]] || ["string"];
                }
            }
        }

        return <Settings  {...this.props} keys={keys}/>;
    }
}



// WEBPACK FOOTER //
// ./src/kpi/components/SettingsModal.jsx